import React, { Suspense, lazy } from "react";
import NewBanner from "./components/NewBanner";
import DynamicSeoPage from "../DynamicSeoPage";

const Areas = lazy(() => import("./components/Areas"));
const HomeListings = lazy(() => import("./components/HomeListings"));
const Testimonials = lazy(() => import("./components/NewTestimonials"));
const About = lazy(() => import("./About"));
const Listwithus = lazy(() => import("./Listwithus"));
const Featured = lazy(() => import("./Featured"));
const NewHome = () => {
  return (
    <div>
      <DynamicSeoPage
        page="home"
        defalut={"365 Luxury Homes - Find your Vacation Holiday in Dubai"}
      />
      <NewBanner />
      <Suspense fallback={null}>
        <Areas />
        <HomeListings />
        <Testimonials />
        <About />
        <Listwithus />
        <Featured />
      </Suspense>
    </div>
  );
};

export default NewHome;
